import builder from '../builder';
import AlarmBell1 from '../../streamline-icons/light/alarm-bell-1.svg';

export default builder('IconAlarmBell1Light', AlarmBell1);
